
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars",
      function () {
        return require("private-next-pages/cars.js");
      }
    ]);
  